module.exports = __webpack_public_path__ + "static/media/19@2x.faf8ef56.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/imgs/19@2x.png
// module id = 378
// module chunks = 0